import React from 'react';
import { Box, Paper, Tab, Tabs } from '@mui/material';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

class BieSimulatorTabs extends React.PureComponent<Props> {
  render() {
    return (
      <Paper elevation={1} sx={{ mb: 2 }}>
        <Tabs
          value={this.props.value}
          onChange={(_, value) => this.props.onChange(value)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab value="assumptions" label="Assumptions" />
          <Tab value="inputs" label="Entries & Import" />
          <Tab value="dashboard" label="Dashboard" />
          <Tab value="analysis" label="Executive Analysis" />
          <Tab value="simulator" label="Interactive Simulation" />
        </Tabs>
      </Paper>
    );
  }
}

export default BieSimulatorTabs;
